import { Component, OnInit, OnDestroy } from '@angular/core';
import { map } from 'rxjs/operators';
import { Subscription } from 'rxjs/index';
import { Router, ActivatedRoute } from '@angular/router';
import { LayoutProviderService } from '../../providers/layout.providers/layout.provider.service';
import { UserService } from '../../providers/user/user.service';

@Component({
  selector: 'ptc-workspace',
  templateUrl: './workspace.layout.template.html',
  styleUrls: ['./workspace.layout.style.scss']
})
export class WorkspaceLayoutComponent implements OnInit, OnDestroy {
  layoutService: LayoutProviderService;
  router: Router;
  activatedRoute: ActivatedRoute;
  routeSubscription: Subscription;
  userSettingsSubscription: Subscription;
  userService: UserService;

  constructor(
    layoutService: LayoutProviderService,
    router: Router,
    activatedRoute: ActivatedRoute,
    userService: UserService
  ) {
    this.layoutService = layoutService;
    this.router = router;
    this.activatedRoute = activatedRoute;
    this.userService = userService;
    this.routeSubscription = this.activatedRoute.data
      .pipe(map((result: any) => result.layout))
      .subscribe(resolved => {
        // layout to use:
        this.router.navigate(['/perspective', resolved.settings.activePerspective]);
      });
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
    if (this.userSettingsSubscription) {
      this.userSettingsSubscription.unsubscribe();
    }
  }
  ngOnInit() {
    this.userSettingsSubscription = this.userService
      .getUserSettings$(this.userService.getUserName())
      .subscribe(() => {});
  }
}
